import { Collapse, Form } from 'react-bootstrap';
import { Button, Label } from '../../atoms';
import React, { FC, useState } from 'react';
import { ArrowDownIcon, ArrowUpIcon } from '../../../assets/icons/svg';
import cn from 'classnames';
import styles from './UploadDocumentOrganism.module.css';
import { FileMeta } from '../../../store/mediaAPI/document/dto/request/document-save-request';
import { FileUploader } from '../../molecules';

interface UploadDocumentProps {
  setFile: (file: string) => void;
  setFileMeta?: (fileMeta: FileMeta) => void;
  setName: (name: string) => void;
  name?: string;
  callbackFn: () => void;
}

const UploadDocument: FC<UploadDocumentProps> = ({
  setFile,
  setFileMeta,
  setName,
  name,
  callbackFn,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [localFile, setLocalFile] = useState<string>();
  const [localName, setLocalName] = useState<string | undefined>(name);

  const handleSubmit: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    callbackFn();
  };

  return (
    <>
      <div className={cn(styles.uploadDocumentWrapper)}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          onClick={() => setOpen(!open)}
        >
          <Label
            style={{ padding: '.5rem 0' }}
            content="Upload Document"
            size="heading-md"
          />
          {open ? <ArrowUpIcon /> : <ArrowDownIcon />}
        </div>
        <Collapse in={open}>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>FileName</Form.Label>
              <FileUploader
                setFile={(file: string) => {
                  setFile(file);
                  setLocalFile(file);
                }}
                setFileMeta={(fileMeta) => {
                  if (setFileMeta) {
                    setFileMeta(fileMeta);
                  }
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Document name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter document name"
                onChange={(e) => {
                  setName(e.target.value);
                  setLocalName(e.target.value);
                }}
                value={name}
              />
            </Form.Group>
            <Button
              onClick={handleSubmit}
              variant="light"
              disabled={!localName || !localFile}
            >
              Upload document
            </Button>
          </Form>
        </Collapse>
      </div>
    </>
  );
};

export default UploadDocument;
